import riskstock from '@/assets/dl-gallery/riskstock-v.png';
import riskstockAvif from '@/assets/dl-gallery/riskstock-v.png?format=avif';
import riskstockWebp from '@/assets/dl-gallery/riskstock-v.png?format=webp';
import przestanSieBac from '@/assets/dl-gallery/przestan-sie-bac.png';
import przestanSieBacAvif from '@/assets/dl-gallery/przestan-sie-bac.png?format=avif';
import przestanSieBacWebp from '@/assets/dl-gallery/przestan-sie-bac.png?format=webp';
import smieciWLapy from '@/assets/dl-gallery/smieci-w-lapy.png';
import smieciWLapyAvif from '@/assets/dl-gallery/smieci-w-lapy.png?format=avif';
import smieciWLapyWebp from '@/assets/dl-gallery/smieci-w-lapy.png?format=webp';
import ptaszki from '@/assets/dl-gallery/ptaszki.png';
import ptaszkiAvif from '@/assets/dl-gallery/ptaszki.png?format=avif';
import ptaszkiWebp from '@/assets/dl-gallery/ptaszki.png?format=webp';
import chelmza from '@/assets/dl-gallery/chelmza-stara-szopa.png';
import chelmzaAvif from '@/assets/dl-gallery/chelmza-stara-szopa.png?format=avif';
import chelmzaWebp from '@/assets/dl-gallery/chelmza-stara-szopa.png?format=webp';
import ospSzynych from '@/assets/dl-gallery/osp-szynych.png';
import ospSzynychAvif from '@/assets/dl-gallery/osp-szynych.png?format=avif';
import ospSzynychWebp from '@/assets/dl-gallery/osp-szynych.png?format=webp';
import wreczenie from '@/assets/dl-gallery/wreczenie-grantow.png';
import wreczenieAvif from '@/assets/dl-gallery/wreczenie-grantow.png?format=avif';
import wreczenieWebp from '@/assets/dl-gallery/wreczenie-grantow.png?format=webp';
import skokRadosci from '@/assets/dl-gallery/skok-radosci.png';
import skokRadosciAvif from '@/assets/dl-gallery/skok-radosci.png?format=avif';
import skokRadosciWebp from '@/assets/dl-gallery/skok-radosci.png?format=webp';
import ksiazkiMikolaj from '@/assets/dl-gallery/ksiazki-mikolaj.png';
import ksiazkiMikolajAvif from '@/assets/dl-gallery/ksiazki-mikolaj.png?format=avif';
import ksiazkiMikolajWebp from '@/assets/dl-gallery/ksiazki-mikolaj.png?format=webp';

export type DLGalleryItem = {
  id: number;
  image: string;
  avif?: string;
  webp?: string;
  title: string;
  municipality?: 'Lisewo' | 'Grudziądz' | 'Książki' | 'Chełmża' | 'Wąpielsk' | 'Ośrodek DL';
  year?: string;
  description: string;
  credit?: string;
};

export const dzialajLokalnieGallery: DLGalleryItem[] = [
  {
    id: 1,
    image: riskstock,
    avif: riskstockAvif,
    webp: riskstockWebp,
    title: 'RiskStock V',
    municipality: 'Grudziądz',
    year: '2024',
    description:
      'Festiwal rockowy połączony ze zbiórką krwi w Sztynwagu — kultowa, cykliczna inicjatywa łącząca muzykę z misją społeczną.',
    credit: 'Fot. Stowarzyszenie No Risk No Fun Grudziądz',
  },
  {
    id: 2,
    image: przestanSieBac,
    avif: przestanSieBacAvif,
    webp: przestanSieBacWebp,
    title: 'Przestań się bać',
    municipality: 'Grudziądz',
    year: '2024',
    description:
      'Bezpłatne kursy pierwszej pomocy przedmedycznej prowadzone przez Stowarzyszenie Razem SMR — masaż serca, opatrywanie ran, postępowanie w sytuacjach zagrożenia życia.',
    credit: 'Fot. Stowarzyszenie Razem SMR',
  },
  {
    id: 3,
    image: smieciWLapy,
    avif: smieciWLapyAvif,
    webp: smieciWLapyWebp,
    title: 'Śmieci w łapy',
    municipality: 'Grudziądz',
    year: '2021–2024',
    description:
      'Cykliczne sprzątanie lasu w towarzystwie psów ze schroniska — działania ekologiczne łączone z promocją adopcji i wolontariatu.',
    credit: 'Fot. Fundacja Dobre Ludki / Fundacja Nasza Ziemia',
  },
  {
    id: 4,
    image: ptaszki,
    avif: ptaszkiAvif,
    webp: ptaszkiWebp,
    title: 'Ptaszki naszej miejscowości',
    municipality: 'Grudziądz',
    year: '2024',
    description:
      'Edukacja przyrodnicza i ornitologiczna mieszkańców Węgrowa — warsztaty plastyczne dla dzieci ukazujące lokalną awifaunę.',
    credit: 'Fot. Mieszkańcy Węgrowa',
  },
  {
    id: 5,
    image: chelmza,
    avif: chelmzaAvif,
    webp: chelmzaWebp,
    title: 'W zdrowym ciele zdrowy duch',
    municipality: 'Chełmża',
    year: '2024',
    description:
      'Edukacja pszczelarska i działania prozdrowotne w Galerii Stara Szopa w Grzywnie — uroczyste podpisanie umów grantowych z udziałem władz Gminy Chełmża.',
    credit: 'Fot. UG Chełmża',
  },
  {
    id: 6,
    image: ospSzynych,
    avif: ospSzynychAvif,
    webp: ospSzynychWebp,
    title: '95-lecie OSP Szynych',
    municipality: 'Grudziądz',
    year: '2025',
    description:
      'Wielki jubileusz Ochotniczej Straży Pożarnej w Szynychu — uroczysta defilada, msza polowa, piknik strażacki i prezentacja sprzętu ratowniczego.',
    credit: 'Fot. OSP Szynych',
  },
  {
    id: 7,
    image: wreczenie,
    avif: wreczenieAvif,
    webp: wreczenieWebp,
    title: 'Wręczenie grantów Działaj Lokalnie',
    municipality: 'Ośrodek DL',
    year: '2024',
    description:
      'Wójt Gminy Grudziądz Andrzej Rodziewicz przyznał 10 000 zł Stowarzyszeniu Kuźnia Inicjatyw Lokalnych w otwartym konkursie ofert na operatora konkursu na mikrodotacje w ramach regrantingu.',
    credit: 'Fot. SKIL Lisewo',
  },
  {
    id: 8,
    image: skokRadosci,
    avif: skokRadosciAvif,
    webp: skokRadosciWebp,
    title: 'Najwyższy Skok Radości',
    municipality: 'Ośrodek DL',
    year: '2025',
    description:
      'Uroczyste wręczenie umów grantowych edycji 2025 — moment, który najlepiej oddaje energię programu Działaj Lokalnie i zaangażowanie grantobiorców.',
    credit: 'Fot. Działaj Lokalnie',
  },
  {
    id: 9,
    image: ksiazkiMikolaj,
    avif: ksiazkiMikolajAvif,
    webp: ksiazkiMikolajWebp,
    title: 'Mikołajkowe inicjatywy w Książkach',
    municipality: 'Książki',
    year: '2023–2024',
    description:
      'Bieg Mikołajkowy, spotkania ze Świętym Mikołajem i wydarzenia integracyjne dla dzieci i rodzin organizowane przez GOK Książki i lokalne stowarzyszenia.',
    credit: 'Fot. Gmina Książki',
  },
];
